import React from "react";
import { motion } from "framer-motion";
import { DESTINATIONS } from "@/data/destinations";

export const CatalogList = () => {
  return (
    <section
      data-testid="catalog-list-section"
      className="relative py-24 sm:py-32 bg-aio-surface"
    >
      <div className="max-w-[1440px] mx-auto px-6 sm:px-12 lg:px-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-16">
          <div className="md:col-span-5">
            <p className="text-[11px] uppercase tracking-[0.32em] text-aio-soft mb-4">
              Every stay, every country
            </p>
            <h2 className="font-display text-5xl sm:text-6xl leading-[1.02] tracking-tighter text-aio-ink">
              The full <span className="italic">catalog</span>.
            </h2>
          </div>
          <div className="md:col-span-5 md:col-start-8 flex md:items-end">
            <p className="text-aio-soft leading-relaxed text-base">
              Every destination in our sourcing network — organized by country.
              Note the ones you love; you&apos;ll list them on the request form
              below.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-14">
          {DESTINATIONS.map((c, idx) => (
            <motion.div
              key={c.country}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.7, delay: (idx % 6) * 0.05 }}
              data-testid={`country-block-${c.country.toLowerCase().replace(/[\s,]+/g, "-")}`}
            >
              <div className="flex items-start gap-4 mb-5">
                <div className="w-16 h-20 shrink-0 overflow-hidden bg-aio-bg">
                  <img
                    src={c.image}
                    alt={c.country}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="pt-1">
                  <p className="text-[10px] uppercase tracking-[0.32em] text-aio-soft mb-2">
                    {String(idx + 1).padStart(2, "0")}
                  </p>
                  <h3 className="font-display text-2xl sm:text-[26px] leading-tight tracking-tight text-aio-ink">
                    {c.country}
                  </h3>
                  <p className="text-[11px] uppercase tracking-[0.22em] text-aio-soft mt-1">
                    {c.spots.length} {c.spots.length === 1 ? "stay" : "stays"}
                  </p>
                </div>
              </div>
              <ul className="border-t border-aio-border/70 divide-y divide-aio-border/50">
                {c.spots.map((s) => (
                  <li
                    key={s}
                    className="py-2.5 text-[14px] text-aio-ink font-light flex items-baseline gap-3"
                  >
                    <span className="text-[10px] tracking-[0.22em] text-aio-olive/80">
                      &mdash;
                    </span>
                    <span>{s}</span>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
